import Label from "components/Label";
import React, { FC } from "react";
import { BsFillCheckCircleFill as Check } from "react-icons/bs";

import styles from "./syles.module.scss";

interface Benefit {
  title: string;
  description: string;
  advantages: string[];
}

type Props = {
  benefits: Benefit[];
};

const BenefitsTable: FC<Props> = ({ benefits }) => {
  return (
    <div className={styles.container}>
      {benefits.map(({ title, description, advantages }) => (
        <div className={styles.section}>
          <div className={styles.subSection}>
            <Label
              className={styles.title}
              breakWord
              color="white"
              variant="h4"
            >
              {title}
            </Label>
          </div>
          <div className={styles.subSection}>
            <Label color="white" variant="s3">
              {description}
            </Label>
          </div>
          <div className={styles.subSection}>
            <div className={styles.advantages}>
              {advantages.map((advantage) => (
                <div className={styles.advantage}>
                  <Check className={styles.check} />
                  <Label variant="s3" color="white">
                    {advantage}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BenefitsTable;
